import { FC } from 'react';

import { SeeMorePublicationsListSkeleton } from './see-more-publications-list-skeleton';
import { SeeMorePublicationsSkeleton } from './see-more-publications-skeleton';

export const SeeMoreThematicsSkeleton: FC = () => (
  <div className="d-flex flex-column">
    <SeeMorePublicationsListSkeleton titleKey="discover.thematics.title" itemsCount={4} />
  </div>
);

export const SeeMoreProductsSkeleton: FC = () => (
  <SeeMorePublicationsSkeleton titleKey="discover.products.title" categoryCount={7} itemsCount={4} />
);
